module.exports = __webpack_public_path__ + "static/media/PayConnectHome.b65f36f0.svg";